import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

const BackgroundImage = styled.div`
  display: flex;
  align-items: flex-end;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  opacity: 0.99;
  height: 18rem;
  padding: 1.5rem;
  background-image: ${({ url }) => `url(${url})`};
  ${EmotionBreakpoint('mobile')} {
    background-image: ${({ mobileUrl, url }) => `url(${mobileUrl || url})`};
  }
  .reference-card-title {
    color: #fff;
    margin: 0;
    font-size: 1.7rem;
    text-align: left;
    line-height: 2rem;
  }
`;
const ReferenceContainer = styled.div`
  background-color: #fff;
  border: 1px solid #ccc;
  .reference-card-content {
    padding: 20px;
  }
  .reference-card-content-text {
    margin: 0 0 10px 0;
    text-align: left;
  }
  .reference-card-promo {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 20px;
    border-top: 1px solid #ccc;
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: rgb(204, 204, 204);
  }
`;

const ReferenceCard = ({ children, cardDetails }) => {
  return (
    <ReferenceContainer className="h-100 reference-card-background">
      <BackgroundImage url={cardDetails?.backgroundImage} mobileUrl={cardDetails?.mobileBackgroundImage}>
        {cardDetails?.title && <h2 className="reference-card-title">{cardDetails?.title}</h2>}
        <p className="reference-card-subtitle"></p>
        <div className="black-opacity" />
      </BackgroundImage>

      <div className="reference-card-content">
        {cardDetails?.content && <p className="reference-card-content-text">{cardDetails?.content}</p>}
        <div className="reference-card-promo">{children}</div>
      </div>
    </ReferenceContainer>
  );
};

export { ReferenceCard };
